var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill-page"},[_vm._m(0),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('CodeCard',{attrs:{"title":"轨迹回放","description":"高德地图轨迹回放功能，支持播放、暂停、继续、停止和速度控制","codeContent":_vm.trackMapCode}},[_c('TrackMap')],1)],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h2',[_vm._v("地图组件技能库")]),_c('p',[_vm._v("展示高德地图API的个性化用法")])])
}]

export { render, staticRenderFns }